import React, { useEffect, useState } from 'react';
import { Row,} from "react-table";

//MUI
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

//Custom Components
import useFormController from "@/components/useFormController";
import formGenerator from "@/lib/formGenerator";

//Types
import { FormControllerProps } from "@/@types/components/formController";
import { PickerItem } from "@/@types/controls/controls";
import { FormFieldControls } from '@/@types/lib/formGenerator';
import { IDataController, DCRecord, DCFieldValue } from "@/@types/lib/dataController"

export interface IEditableRow {
  dc: IDataController;
  row: Row;
  form: string;
  cellFocus: string;
  onRecordChanged?: (record: DCRecord | null, includeGeom?: boolean) => void;
  onFieldChangeFn?: Function;
  autoSave?: boolean;
}


function EditableRow(props: IEditableRow) {
  const { dc, row, form, cellFocus, onRecordChanged, onFieldChangeFn } = props;

  // we need form controller to handle values, validation, etc.
  const { record, validation, onFieldChange, subModels, fields, doUpdate} = useFormController(
    {
      dc: dc,
      form: form,
      mode: "update",
      initialRecord: row.original
    } as FormControllerProps
  );

  // const onFieldChangeWrapper = (value: DCFieldValue, source: string) => {
  //   if (source !== 'kat_tip_id') {
  //     onFieldChange(value, source);
  //     if (onFieldChangeFn) {
  //       onFieldChangeFn(value, source);
  //     }
  //   } else if (!value || value && typeof value === 'object' && 'value' in value && (value as PickerItem).value === S.kat_tip_id['T']) {
  //     onFieldChange(value, source);
  //     if (onFieldChangeFn) {
  //       onFieldChangeFn(value, source);
  //     }
  //   } else if (record.allowPodrumAndSuteren) {
  //     onFieldChange(value, source);
  //     if (onFieldChangeFn) {
  //       onFieldChangeFn(value, source);
  //     }
  //   } else {
  //     // do nothing
  //   }
  // }

  const onFieldChangeWrapper = (value: DCFieldValue, source: string) => {
    onFieldChange(value, source);
    if (onFieldChangeFn) {
      onFieldChangeFn(value, source, onFieldChange);
    }
  }

  // we need formGenerator to generate controls for given fields
  const fg = new formGenerator();

  // controls to show
  const controls: FormFieldControls = fg.generateFormControls(
    fields,
    "table",
    "edit",
    record,
    validation,
    onFieldChangeWrapper,
    subModels
  )

  useEffect(() => {
    // @ts-ignore
    if (onFieldChange && window.__GlobalState['button-group-ctrl']) {
      const field = fields.find(f => f.type === 'buttonGroup');
      if (field) {
        // @ts-ignore
        const item = window.__GlobalState['button-group-ctrl'];
        onFieldChange(item, field.source);
        if (onFieldChangeFn) {
          onFieldChangeFn(item, field.source, onFieldChange);
        }
        // @ts-ignore
        window.__GlobalState['button-group-ctrl'] = null;
      }
    }
  }, [onFieldChange])

  const handleAction = (action: string, id: number, onEditingClosed: Function) => {
    switch (action) {
      case "confirm":
        //temp:
        if (onRecordChanged) {
          onRecordChanged(record);
        }
        onEditingClosed();
        if (onFieldChangeFn) {
          onFieldChangeFn({}, null);
        }

        // we dont need this since we want to patch the record from the parent component
        // doUpdate().then((resp) => {
        //   if (resp.success) {
        //     if (onRecordChanged) {
        //       onRecordChanged(record);
        //     }
        //     onEditingClosed();
        //   } else {
        //     if (resp.validationPass === false) {
        //       //do nothing
        //     }
        //   }
        // })
        break;
      case "confirm_with_geom":
        if (onRecordChanged) {
          onRecordChanged(record, true);
        }
        onEditingClosed();
        if (onFieldChangeFn) {
          onFieldChangeFn({}, null);
        }
        break;
      case "cancel":
        onEditingClosed();
        if (onFieldChangeFn) {
          onFieldChangeFn({}, null);
        }
        break;
      default:
        console.log("action not defined: " + action)
        break;
    }
  }
  
  return (
    <TableRow
      hover={true}
      selected={true}
      role="check"
      aria-checked={true}
      {...row.getRowProps()}
    >
      {row.cells.map((cell) => {
        return <TableCell {...cell.getCellProps({
          style: {
            overflowWrap: "break-word",
            cursor: "pointer",
          }
        })} size="small">
           {cell.render("Cell", {
            // handleChange,
            handleAction,
            value: record && record[cell.column.id],
            focused: cellFocus === cell.column.id,
            control: controls[cell.column.id], //control is passed to RenderFn,
            editingRecordId: record.id as number
          })}
        </TableCell>;
      })}
    </TableRow>
  );
}

export default EditableRow;